import React, { useEffect, useState, Fragment, useRef } from "react";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import '../../../../assets/css/print.css';
var QRCode = require("qrcode.react");

export default class ComponentToPrint extends React.Component {

  render() {
    var data = this.props.data;
    var isPrint = this.props.isPrint;
    return (

      <table className="display dataTable no-footer">
        {
          data.map((d, i, e) => {
            return (
              <div key={i} style={{pageBreakBefore: "always"}}>
                {isPrint.isActive == true && <div className="col-sm p-3" style={{marginTop: 150}} >
                  <QRCode value={d.tagNo} size={800} />
                  <div style={{textAlign: "center", fontSize: 100}}> {d.tagNo} </div>
                </div> }
                {isPrint.isActive == false && <div className="col-sm p-3" style={{ marginTop: 200}}>
                  <QRCode value={d.tagNo} size={800}/>
                </div> }
                
              </div>
            )
          })
        }
      </table>
      
    );
  };
}


















